export default __webpack_public_path__ + "static/media/image2-home7.44628bcd.png";